export const ACTION_ENUM = Object.freeze({
  REQUEST_CALLBACK: 'REQUEST_CALLBACK',
  RE_APPLY_JOURNEY: 'RE_APPLY_JOURNEY',
  WITHDRAWAL_JOURNEY: 'WITHDRAWAL_JOURNEY',
  NEW_APPLICATION: 'NEW_APPLICATION',
  APPLICATIONS_DASHBOARD: 'APPLICATIONS_DASHBOARD'
});

export const PRODUCT_CONFIG = {
  'LLL#BTA': {
    productName: 'Fixed Term Funding',
    cta: {
      ACTIVE: { label: 'Request a callback', action: ACTION_ENUM.REQUEST_CALLBACK },
      ACTIVE_INELIGIBLE: { label: 'Active', action: null, disabled: true },
      CLOSED: { label: 'Re-apply Now', action: ACTION_ENUM.RE_APPLY_JOURNEY },
      NONE: { label: 'Apply Now', action: ACTION_ENUM.NEW_APPLICATION },
      PENDING: { label: 'In Progress', action: ACTION_ENUM.APPLICATIONS_DASHBOARD, disabled: true }
    }
  },
  'LLL#RCF': {
    productName: 'Cash Flow Facility',
    cta: {
      ACTIVE: { label: 'Withdraw Now', action: ACTION_ENUM.WITHDRAWAL_JOURNEY },
      CLOSED: { label: 'Apply Now', action: ACTION_ENUM.NEW_APPLICATION },
      NONE: { label: 'Apply Now', action: ACTION_ENUM.NEW_APPLICATION },
      PENDING: { label: 'In Progress', action: ACTION_ENUM.APPLICATIONS_DASHBOARD, disabled: true }
    }
  }
};

export const getProductConfig = (productKey) => {
  if (!productKey || !PRODUCT_CONFIG[productKey]) {
    return null;
  }
  return PRODUCT_CONFIG[productKey];
};

export const resolveCtaStatus = (productKey, lenderStatus, { inProgressProductKeys = [], isReadvanceEligible } = {}) => {
  if (productKey === 'LLL#BTA' && lenderStatus === 'ACTIVE' && !isReadvanceEligible) {
    return 'ACTIVE_INELIGIBLE';
  }
  if (inProgressProductKeys.includes(productKey)) {
    return 'PENDING';
  }
  return lenderStatus;
};

export const getCtaConfig = (productKey, lenderStatus, options) => {
  const config = getProductConfig(productKey);
  if (!config || !config.cta) {
    return null;
  }
  const resolvedStatus = options ? resolveCtaStatus(productKey, lenderStatus, options) : lenderStatus;
  return config.cta[resolvedStatus] || config.cta['NONE'] || null;
};